/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { loadDraftsIfNeeded, loadDraft } from '../../store/draft/draft.js';
import { loadCompositionsIfNeeded, loadComposition } from '../../store/comp/comp.js';
import { loadLtiItemsIfNeeded, loadLtiItem, loadSuppliers, loadKeySecrets } from '../../store/lti/lti.js';
import { loadLtiAdvantageItemsIfNeeded, loadLtiAdvantageItem } from '../../store/ltiAdvantage/ltiAdvantage.js';
import { loadDeployments } from '../../store/ltiAdvantage/deployments.js';
import { loadScormItemsIfNeeded, loadScormItem } from '../../store/scorm/scorm.js';
import { loadOsItemsIfNeeded, loadOsItem } from '../../store/os/os.js';
import { loadYoutubeItemsIfNeeded, loadYoutubeItem } from '../../store/youtube/youtube.js';
import { loadVimeoItemsIfNeeded, loadVimeoItem } from '../../store/vimeo/vimeo.js';
import { notifyDone } from '../../store/notify/notify.js';
import { navigated } from '../../store/route/route.js'
import { loadAccreditationInfo, loadAccreditationInfosIfNeeded } from '../../store/accreditationInfo/accreditationInfo.js';
import { loadAccreditations, loadAccreditationsIfNeeded } from '../../store/accreditation/accreditation.js';
import '../accreditation/sdb-accreditation-info-list.js';
import '../accreditation/sdb-accreditations-list.js';
import { getCatalogItemReplaceStatus } from '../../store/catalog/catalog.js';
import { applyStyles } from '../../helpers/stylesheets.js';
import { Routes } from '@lit-labs/router';
import '@polymer/paper-toast/paper-toast.js';
import '../draft/sdb-composition-draft-list.js';
import '../draft/sdb-composition-draft.js';
import '../composition/sdb-composition-list.js';
import '../composition/sdb-composition.js';
import '../lti/sdb-lti-item-list.js';
import '../lti/sdb-lti-item.js';
import '../ltiAdvantage/sdb-lti-advantage-item-list.js';
import '../ltiAdvantage/sdb-lti-advantage-item.js';
import '../scorm/sdb-scorm-item-list.js';
import '../scorm/sdb-scorm-item.js';
import '../os/sdb-os-item-list.js';
import '../os/sdb-os-item.js';
import '../youtube/sdb-youtube-item-list.js';
import '../youtube/sdb-youtube-item.js';
import '../vimeo/sdb-vimeo-item-list.js';
import '../vimeo/sdb-vimeo-item.js';
import '../composition/sdb-accreditation-info.js';
import '../composition/sdb-composition-accreditations.js';
import '../shared/sdb-overlay-element.js';

const MAX_BACK_STACK = 20;

@customElement('sdb-composition-editor')
class SdbCompositionEditor extends connect(store)(LitElement) {

    @state()
    accessor path;

    @state()
    accessor message;

    constructor() {
        super();

        this._routes = new Routes(this, [
            {
                path: 'drafts',
                render: () => html`<sdb-composition-draft-list></sdb-composition-draft-list>`,
                enter: async () => {
                    store.dispatch(loadDraftsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'draft/:id',
                render: ({ id }) => html`
                    <sdb-overlay-element>
                        <sdb-composition-draft draftId=${id}></sdb-composition-draft>
                    </sdb-overlay-element>
                `,
                enter: async ({ id }) => {
                    store.dispatch(loadDraft({ draftId: id }));
                }
            },
            {
                path: 'compositions',
                render: () => html`<sdb-composition-list></sdb-composition-list>`,
                enter: async () => {
                    store.dispatch(loadCompositionsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'composition/:id',
                render: ({ id }) => html`
                    <sdb-overlay-element>
                        <sdb-composition targetId=${id}></sdb-composition>
                    </sdb-overlay-element>
                `,
                enter: async ({ id }) => {
                    store.dispatch(loadComposition({ targetId: id }));
                    store.dispatch(getCatalogItemReplaceStatus({ targetId: id }));
                }
            },
            {
                path: 'composition/:id/accreditationinfo',
                render: ({ id }) => html`
                    <sdb-overlay-element>
                        <sdb-accreditation-info targetId=${id}></sdb-accreditation-info>
                    </sdb-overlay-element>
                    `,
                enter: async ({ id }) => {
                    store.dispatch(loadAccreditationInfo({ targetId: id }));
                }
            },
            {
                path: 'composition/:id/accreditations',
                render: ({ id }) => html`
                    <sdb-overlay-element>
                        <sdb-composition-accreditations targetId=${id}></sdb-composition-accreditations>
                    </sdb-overlay-element>
                `,
                enter: async ({ id }) => {
                    store.dispatch(loadComposition({ targetId: id }));
                    store.dispatch(loadAccreditations({ targetId: id }));
                }
            },
            {
                path: 'accreditationInfos',
                render: () => html`<sdb-accreditation-info-list></sdb-accreditation-info-list>`,
                enter: async () => {
                    store.dispatch(loadAccreditationInfosIfNeeded({ reload: true }));
                }
            },
            {
                path: 'accreditations',
                render: () => html`<sdb-accreditation-list></sdb-accreditation-list>`,
                enter: async () => {
                    store.dispatch(loadAccreditationsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'lti',
                render: () => html`<sdb-lti-item-list></sdb-lti-item-list>`,
                enter: async () => {
                    store.dispatch(loadLtiItemsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'ltiitem/:id',
                render: ({ id }) => html`
                    <sdb-overlay-element>
                        <sdb-lti-item ltiItemId=${id}></sdb-lti-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ id }) => {
                    store.dispatch(loadLtiItem({ uniqueId: id }));
                    store.dispatch(loadSuppliers());
                    store.dispatch(loadKeySecrets());
                }
            },
            {
                path: 'lti-advantage',
                render: () => html`<sdb-lti-advantage-item-list></sdb-lti-advantage-item-list>`,
                enter: async () => {
                    store.dispatch(loadLtiAdvantageItemsIfNeeded({ reload: true }));
                    store.dispatch(loadDeployments());
                }
            },
            {
                path: 'ltiadvantageitem/:targetId',
                render: ({ targetId }) => html`
                    <sdb-overlay-element>
                        <sdb-lti-advantage-item targetId=${targetId}></sdb-lti-advantage-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ targetId }) => {
                    store.dispatch(loadLtiAdvantageItem({ targetId }));
                    store.dispatch(loadDeployments());
                }
            },
            {
                path: 'scorm',
                render: () => html`<sdb-scorm-item-list></sdb-scorm-item-list>`,
                enter: async () => {
                    store.dispatch(loadScormItemsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'scormitem/:targetId',
                render: ({ targetId }) => html`
                    <sdb-overlay-element>
                        <sdb-scorm-item targetId=${targetId}></sdb-scorm-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ targetId }) => {
                    store.dispatch(loadScormItem({ targetId }));
                }
            },
            {
                path: 'os',
                render: () => html`<sdb-os-item-list></sdb-os-item-list>`,
                enter: async () => {
                    store.dispatch(loadOsItemsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'ositem/:targetId',
                render: ({ targetId }) => html`
                    <sdb-overlay-element>
                        <sdb-os-item targetId=${targetId}></sdb-os-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ targetId }) => {
                    store.dispatch(loadOsItem({ targetId }));
                }
            },
            {
                path: 'youtube',
                render: () => html`<sdb-youtube-item-list></sdb-youtube-item-list>`,
                enter: async () => {
                    store.dispatch(loadYoutubeItemsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'youtubeitem/:targetId',
                render: ({ targetId }) => html`
                    <sdb-overlay-element>
                        <sdb-youtube-item targetId=${targetId}></sdb-youtube-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ targetId }) => {
                    store.dispatch(loadYoutubeItem({ targetId }));
                }
            },
            {
                path: 'vimeo',
                render: () => html`<sdb-vimeo-item-list></sdb-vimeo-item-list>`,
                enter: async () => {
                    store.dispatch(loadVimeoItemsIfNeeded({ reload: true }));
                }
            },
            {
                path: 'vimeoitem/:targetId',
                render: ({ targetId }) => html`
                    <sdb-overlay-element>
                        <sdb-vimeo-item targetId=${targetId}></sdb-vimeo-item>
                    </sdb-overlay-element>
                `,
                enter: async ({ targetId }) => {
                    store.dispatch(loadVimeoItem({ targetId }));
                }
            },
        ]);
    }

    get toast() {
        return document.getElementById('editor_toast');
    }

    set path(val) {
        if (val) {
            this._goto(val, this._navigateBack);
        }
    }

    set message(val) {
        if (val) {
            this._showMessage(val);
        }
    }

    stateChanged(state) {
        this.userName = state.auth.user?.profile?.name;
        this._navigateBack = state.route.back;
        this.path = state.route.path;
        this.message = state.notify.text;
    }

    static get editorStyles() {
        return css`
            paper-toast.editor-toast {
                text-align: center;
                z-index: 3000;
            }

            vaadin-dialog-overlay::part(overlay) {
                max-width: 100%;
            }
        `;
    }

    render() {
        return html`
            <div>${this._routes.outlet()}</div>
            <sdb-overlay-element>
                <paper-toast id="editor_toast" class="editor-toast"></paper-toast>
            </sdb-overlay-element>
        `;
    }

    firstUpdated() {
        applyStyles(SdbCompositionEditor.editorStyles);
    }

    // todo: rewrite this with redux-saga
    // Every history entry keeps the in-app paths that led to it (backStack), so
    // navigateBack returns to the view the user came from. history.state survives
    // a page refresh and is per tab. Links handled by the host router start a new
    // entry without a backStack, so views then fall back to their default parent.
    async _goto(path, back = false) {
        // Every dispatch below runs stateChanged again before it returns. route.path is
        // only cleared once navigated() reaches the reducer, and a middleware may dispatch
        // an action of its own first: redux-oidc dispatches LOADING_USER for every action
        // while it has no user, which is always the case when the editor is embedded.
        // Acting on that stale path again re-entered _goto without end (#7614).
        if (!path || path === this._clearingPath) { return; }

        this._clearingPath = path;
        try {
            store.dispatch(navigated());
        } finally {
            this._clearingPath = null;
        }

        const previous = window.history.state?.backStack ?? [];
        let backStack;
        if (back) {
            path = previous.at(-1) ?? path;
            backStack = previous.slice(0, -1);
        } else {
            const currentPath = window.location.pathname.substring(this._basePath().length);
            backStack = currentPath && currentPath !== path
                ? [...previous, currentPath].slice(-MAX_BACK_STACK)
                : previous;
        }

        await this._routes.goto(path);

        window.history.pushState({ backStack }, '', this._basePath() + path);
    }

    _basePath() {
        const parentPath = (this._routes._parentRoutes || {})._currentPathname || '/';

        return parentPath !== '/'
            ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf(parentPath) + parentPath.length)
            : '/';
    }

    // todo: logic and template should be in a new component
    _showMessage(text) {
        // Same re-entry as in _goto: notify.text is still set while notifyDone() is on
        // its way through the middleware.
        if (text === this._clearingMessage) { return; }

        this.toast.text = text;
        this.toast.show();

        this._clearingMessage = text;
        try {
            store.dispatch(notifyDone());
        } finally {
            this._clearingMessage = null;
        }
    }
}

